import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	stroke: "#262626",
	fill: "none",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.752 19.579C13.639 20.305 12 22.125 12 22.125V4.712S9.545 1.985 1.268 1.875a.506.506 0 0 0-.366.15.522.522 0 0 0-.152.369v16.375c-.002.28.22.51.5.519C9.543 19.4 12 22.125 12 22.125m0-17.413s2.455-2.727 10.732-2.837a.506.506 0 0 1 .366.15.52.52 0 0 1 .152.369v12.231",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.75 19.564v-4.39a.557.557 0 0 1 .563-.549h3.937l-4.5 4.939Z",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20stroke%3D%22%23262626%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M18.752%2019.579C13.639%2020.305%2012%2022.125%2012%2022.125V4.712S9.545%201.985%201.268%201.875a.506.506%200%200%200-.366.15.522.522%200%200%200-.152.369v16.375c-.002.28.22.51.5.519C9.543%2019.4%2012%2022.125%2012%2022.125m0-17.413s2.455-2.727%2010.732-2.837a.506.506%200%200%201%20.366.15.52.52%200%200%201%20.152.369v12.231%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M18.75%2019.564v-4.39a.557.557%200%200%201%20.563-.549h3.937l-4.5%204.939Z%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
